// extracted by mini-css-extract-plugin
module.exports = {"heading-increment":"styles_heading-increment__8EIQ5"};